<template>
  <div class="footer">
      <div class="one">新一代员工福利</div>
      <div class="englinsh">EMPLOYEE WELFARE </div>
      <div class="newplemy">更健康的员工，更高的工作效率</div>
      <div class="foot_btn" @click="showModal()">联系我们</div>
      <div class="foot_link">  <img src='@/images/tel.png'> <span>服务热线：</span> <span>010-50914766</span></div>
      <div class="foot_time">   <img src='@/images/time.png'><span>服务时间：</span> <span>09:00 am-18:00 pm</span></div>
      <!-- <div class="foot_pos"> -->
          <div class="foot_small_txt">京ICP备19025101号-1  |  Copynight © 2019  |  远通（北京）保险经纪</div>
          <!-- <div class="foot_big_txt">互联网药品信息服务资格证书编号 （京）-经营性-2018-0222 （京）-非经营性-2015-0200 （京）-非经营性-2</div> -->
      <!-- </div> -->
                   <v-modal :visible="visible" @onCloseModal="handleCloseModal"></v-modal>     

  </div>
</template>

<script>
import vModal from '@/components/modal'
export default {
   components: {
    vModal,
  },
  data(){
    return{
         visible: false,
    }
  },
 methods: {

    showModal() {
        this.visible = true;
      },
        handleCloseModal (val) {
      this.visible = val
    }
 }
}
</script>

<style>
.footer{
  width: 100%;
  /* height: 510px; */
  background: #F76D32;
  text-align: center;
  color:#fff;
}
.one{
  padding-top:55px;
  font-size: 26px;
}
.englinsh{
  margin-top: -30px;
  opacity:0.2;
  font-size: 30px;
  color:#E2E4E8;
}
.newplemy{
  margin-top: 12px;
  font-size: 16px;
}
.foot_btn{
  margin:0 auto;
   cursor: pointer;
  margin-top: 42px;
  width: 122px;
  height: 42px;
  line-height: 40px;
  border:2px solid #fff;
   border-radius: 30px;
  text-align: center;
}
.foot_link{
  margin-top:50px;
  font-size: 14px;
}
.foot_link img,.foot_time img{
 margin-right: 10px;
  width:15px;
  height: 15px;;
}
.foot_time img{
  margin-right: 15px;
}
.foot_time{
  margin-top: 6px;
  padding-left: 22px;
}

.foot_small_txt{
  margin-top: 60px;
   font-size: 12px;
}
.foot_big_txt{
      margin-top: 13px;
      font-size: 14px;
}
</style>